module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Typ linku",
      "error": _vm.anchorErrors()
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Wybierz typ linku",
      "clearable": ""
    },
    on: {
      "change": _vm.resetOptions
    },
    model: {
      value: (_vm.form.anchor_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "anchor_type", $$v)
      },
      expression: "form.anchor_type"
    }
  }, _vm._l((_vm.anchorOptions), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Otwieraj w nowym oknie",
      "label-width": "200px"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.target_blank),
      callback: function($$v) {
        _vm.$set(_vm.form, "target_blank", $$v)
      },
      expression: "form.target_blank"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.anchor_type === 'url') ? _c('el-form-item', {
    attrs: {
      "label": "URL",
      "error": _vm.errorsParsed.url
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", $$v)
      },
      expression: "form.url"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [(_vm.form.anchor_type === 'event') ? _c('el-form-item', {
    attrs: {
      "label": "Wydarzenie",
      "error": _vm.errorsParsed.event
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz wydarzenie"
    },
    on: {
      "change": function($event) {
        delete _vm.form['widget']
      }
    },
    model: {
      value: (_vm.form.event),
      callback: function($$v) {
        _vm.$set(_vm.form, "event", $$v)
      },
      expression: "form.event"
    }
  }, _vm._l((_vm.availableLinkOptions.event), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.anchor_type === 'page') ? _c('el-form-item', {
    attrs: {
      "label": "Podstrona",
      "error": _vm.errorsParsed.page
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz podstronę"
    },
    on: {
      "change": function($event) {
        delete _vm.form['widget']
      }
    },
    model: {
      value: (_vm.form.page),
      callback: function($$v) {
        _vm.$set(_vm.form, "page", $$v)
      },
      expression: "form.page"
    }
  }, _vm._l((_vm.availableLinkOptions.page), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.anchor_type === 'stand') ? _c('el-form-item', {
    attrs: {
      "label": "Stoiska",
      "error": _vm.errorsParsed.stand
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz stoiska"
    },
    on: {
      "change": function($event) {
        delete _vm.form['widget']
      }
    },
    model: {
      value: (_vm.form.stand),
      callback: function($$v) {
        _vm.$set(_vm.form, "stand", $$v)
      },
      expression: "form.stand"
    }
  }, _vm._l((_vm.availableLinkOptions.stand), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.anchor_type === 'news') ? _c('el-form-item', {
    attrs: {
      "label": "Aktualność",
      "error": _vm.errorsParsed.news
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Wybierz aktualność"
    },
    on: {
      "change": function($event) {
        delete _vm.form['widget']
      }
    },
    model: {
      value: (_vm.form.news),
      callback: function($$v) {
        _vm.$set(_vm.form, "news", $$v)
      },
      expression: "form.news"
    }
  }, _vm._l((_vm.availableLinkOptions.news), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.availableWidgets.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Nazwa widgetu",
      "error": _vm.errorsParsed.widget
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                Nazwa widgetu\n                "), _c('el-tooltip', {
    attrs: {
      "content": "Widget, do którego domyślnie przescrolluje się strona po kliknięciu w link.",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    staticClass: "widget-info"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Wybierz widget"
    },
    model: {
      value: (_vm.form.widget),
      callback: function($$v) {
        _vm.$set(_vm.form, "widget", $$v)
      },
      expression: "form.widget"
    }
  }, _vm._l((_vm.availableWidgets), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.name_pl,
        "value": option.id
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6966b4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkComponent.vue
// module id = 808
// module chunks = 0